<template>
  <div class="blog">
    <ul class="row" v-if="blogs">
      <li class="col-md-6 col-12" v-for="(item,index) in blogs" :key="index">
        <router-link :to="{ name: 'BlogInterna', params: { slug: item.slug }}">
          <div class="blog__image w-100 ui-image--cover" :style="'background-image: url(' + item.image + ');'"></div>
          <div class="blog__box">
            <div class="blog__box__categories">
              <div class="row">
                <span v-for="(tag, index) in item.tags" :key="index">
                  {{tag.name}}
                </span>
              </div>
            </div>
            <div class="blog__box__title">
              <h2>
                {{item.title}}
              </h2>
            </div>
            <div class="blog__box__action">
              <div class="row">
                <div class="text-left col-6">
                  <div class="know">
                    Leia mais
                  </div>
                </div>
                <div class="text-right col-6">
                  <img src="../assets/img/icon-share.png" alt="Compartilhar">
                </div>
              </div>
            </div>
          </div>
        </router-link>
      </li>
    </ul>
    <div v-if="!blogs.length >= 1">
      <p>Nenhum blog encontrado :(</p>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    'blogs'
  ]
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/_variables.scss';
.blog {
  &__image {
    border-radius: 10px 10px 0 0;
    box-shadow: 10px 0px 35px 0px rgba(0, 26, 66, 0.2);
    height: 380px;
    position: relative;
    &:before {
      background: url(../assets/img/know_more.png);
      content: '';
      height: 82px;
      left: calc(50% - 41px);
      opacity: 0;
      position: absolute;
      top: calc(50% - 41px);
      transition: all 0.3s;
      width: 82px;
    }
  }
  &__box {
    background: white;
    box-shadow: 20px 20px 35px 0px rgba(0, 26, 66, 0.2);
    border-radius: 0 0 10px 10px;
    overflow: hidden;
    padding: 20px 20px 10px 20px;
    transition: all 0.3s;
    &__categories {
      margin-bottom: 30px;
      padding-left: 10px;
      span {
        background: $primary;
        border-radius: 10px;
        color: white;
        font-size: 14px;
        font-style: italic;
        font-weight: 300;
        margin: 0 5px;
        padding: 5px 10px;
      }
    }
    &__title {
      h2{
        color: $primary;
        font-size: 24px;
        font-style: italic;
        font-weight: 600;
        line-height: 32px;
      }
      margin-bottom: 20px;
      min-height: 80px;
    }
    &__action {
      position: relative;
      padding-top: 20px;
      .know {
        color: $green;
        font-size: 16px;
      }
      &:before {
        background: #d8dade;
        content: '';
        height: 1px;
        left: -20px;
        position: absolute;
        top: 0px;
        width: calc(100% + 40px);
      }
    }
  }
  li {
    margin-bottom: 30px;
    transition: all 0.3s;
    &:hover {
      .blog {
        &__image {
          &:before {
            transition: all 0.3s;
            opacity: 1;
          }
        }
        &__box {
          transition: all 0.3s;
          opacity: 0.9;
        }
      }
    }
  }
  @media (max-width: 1200px){
    &__image {
      height: 300px;
    }
    &__box__title {
      h2{
        font-size: 20px;
      }
    }
  }
  @media (max-width: 991px){
     &__box__title {
      h2{
        font-size: 18px;
      }
    }
  }
  @media (max-width: 767px){
    &__box__title {
      min-height: inherit;
    }
    &__box__categories {
      margin-bottom: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BlogCard.vue